"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var input_wrapper_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/input_wrapper"));
var store_component_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/store_component"));
var wrappableWith = function (previous) { return (previous !== undefined && !previous.unwrapped && !previous.hidden); };
var InputList = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    var inputStores = store.inputStores.slice();
    return (react_1.default.createElement(react_1.default.Fragment, null, inputStores.map(function (inputStore, idx) {
        if (inputStore.unwrapped) {
            return wrappableWith(inputStores[idx - 1]) ? null : react_1.default.createElement(store_component_1.default, { key: idx, store: inputStore });
        }
        var nextStore = inputStores[idx + 1];
        var appendix = (nextStore === null || nextStore === void 0 ? void 0 : nextStore.unwrapped) && wrappableWith(inputStore)
            ? react_1.default.createElement(store_component_1.default, { store: nextStore })
            : undefined;
        return (react_1.default.createElement(input_wrapper_1.default, { key: idx, store: inputStore, appendix: appendix },
            react_1.default.createElement(store_component_1.default, { store: inputStore })));
    })));
});
exports.default = InputList;
